import { Text, Colors } from "../../../odc-ui";
import styled from "styled-components/macro";

const ErrorText = styled(Text)`
  color: ${Colors.red200};
`;

export default ErrorText;
